module.exports = __webpack_public_path__ + "8e7266cdba2b96c5f3af6e8d05f2d454.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarArabella3.png
// module id = 52
// module chunks = 0